import { render, staticRenderFns } from "./InteractionsPerShortLinkTag.vue?vue&type=template&id=ecf2151e"
import script from "./InteractionsPerShortLinkTag.vue?vue&type=script&lang=ts"
export * from "./InteractionsPerShortLinkTag.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports